// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page_loginPage__vMRYF {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background:
        linear-gradient(180deg, #000000 15.29%, rgba(0, 0, 0, 0) 100%),
        conic-gradient(from 34.81deg at 101.94% 101.46%, #475F02 -28.12deg, #4C0700 43.42deg, #533800 144.36deg, #0C2B4F 231.96deg, #475F02 331.88deg, #4C0700 403.42deg);
}

.login-page_Tree__C1M7c {
    position: absolute;
    /* Reference: 622.92x565.82 at 1536x864, positioned at top:-49.83px, left:700.44px, rotated -36.52deg */
    width: 40.554vw;
    /* 622.92 / 1536 * 100 */
    height: auto;
    max-width: 622.92px;
    top: 3.768vh;
    /* -49.83 / 864 * 100 */
    left: 50.601vw;
    /* 700.44 / 1536 * 100 */
    transform: rotate(10deg);
}

.login-page_Frog__lXo8\\+ {
    position: absolute;
    /* Reference: 561x483 at 1536x864, positioned at top:454px */
    width: 36.523vw;
    /* 561 / 1536 * 100 */
    height: auto;
    max-width: 561px;
    top: 43vh;
    /* 454 / 864 * 100 */
    left: 0;
    z-index: 1;
}

/* Tablet screens */
@media (min-width: 769px) and (max-width: 1024px) {
    .login-page_Tree__C1M7c {
        width: 50vw;
        top: 0;
        left: 40vw;
        transform: rotate(10deg);
    }

    .login-page_Frog__lXo8\\+ {
        width: 40vw;
        top: auto;
        bottom: 0;
        left: -5%;
    }
}

/* Mobile screens */
@media (max-width: 768px) {
    .login-page_Tree__C1M7c {
        width: 90vw;
        top: 9.1%;
        left: 30vw;
        transform: rotate(10deg);
    }

    .login-page_Frog__lXo8\\+ {
        width: 60vw;
        top: auto;
        bottom: 0;
        left: -10%;
    }
}`, "",{"version":3,"sources":["webpack://./src/features/auth/pages/login-page.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB;;yKAEqK;AACzK;;AAEA;IACI,kBAAkB;IAClB,uGAAuG;IACvG,eAAe;IACf,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,4DAA4D;IAC5D,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,OAAO;IACP,UAAU;AACd;;AAEA,mBAAmB;AACnB;IACI;QACI,WAAW;QACX,MAAM;QACN,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,SAAS;QACT,SAAS;QACT,SAAS;IACb;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,WAAW;QACX,SAAS;QACT,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,SAAS;QACT,SAAS;QACT,UAAU;IACd;AACJ","sourcesContent":[".loginPage {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    background:\n        linear-gradient(180deg, #000000 15.29%, rgba(0, 0, 0, 0) 100%),\n        conic-gradient(from 34.81deg at 101.94% 101.46%, #475F02 -28.12deg, #4C0700 43.42deg, #533800 144.36deg, #0C2B4F 231.96deg, #475F02 331.88deg, #4C0700 403.42deg);\n}\n\n.Tree {\n    position: absolute;\n    /* Reference: 622.92x565.82 at 1536x864, positioned at top:-49.83px, left:700.44px, rotated -36.52deg */\n    width: 40.554vw;\n    /* 622.92 / 1536 * 100 */\n    height: auto;\n    max-width: 622.92px;\n    top: 3.768vh;\n    /* -49.83 / 864 * 100 */\n    left: 50.601vw;\n    /* 700.44 / 1536 * 100 */\n    transform: rotate(10deg);\n}\n\n.Frog {\n    position: absolute;\n    /* Reference: 561x483 at 1536x864, positioned at top:454px */\n    width: 36.523vw;\n    /* 561 / 1536 * 100 */\n    height: auto;\n    max-width: 561px;\n    top: 43vh;\n    /* 454 / 864 * 100 */\n    left: 0;\n    z-index: 1;\n}\n\n/* Tablet screens */\n@media (min-width: 769px) and (max-width: 1024px) {\n    .Tree {\n        width: 50vw;\n        top: 0;\n        left: 40vw;\n        transform: rotate(10deg);\n    }\n\n    .Frog {\n        width: 40vw;\n        top: auto;\n        bottom: 0;\n        left: -5%;\n    }\n}\n\n/* Mobile screens */\n@media (max-width: 768px) {\n    .Tree {\n        width: 90vw;\n        top: 9.1%;\n        left: 30vw;\n        transform: rotate(10deg);\n    }\n\n    .Frog {\n        width: 60vw;\n        top: auto;\n        bottom: 0;\n        left: -10%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginPage": `login-page_loginPage__vMRYF`,
	"Tree": `login-page_Tree__C1M7c`,
	"Frog": `login-page_Frog__lXo8+`
};
export default ___CSS_LOADER_EXPORT___;
